// _______App
import imageGuia from '../assets/images/portfolio/portfolioApp/appGuia.webp'
import imageMosaikus from '../assets/images/portfolio/portfolioApp/portafolioAppMosaikus.webp'
import imageDigipagos from '../assets/images/portfolio/portfolioApp/portafolioAppDigipagos.webp'
import imageMarco from '../assets/images/portfolio/portfolioApp/portafolioAppMarcoAldany.webp'
import imageGlobal from '../assets/images/portfolio/portfolioApp/portafolioAppGlobal.webp'
// _____Diseno
import imageCachamay from '../assets/images/portfolio/portfolioDesign/portafolioDisenoCachamayRunners.webp'
import imageSensi from '../assets/images/portfolio/portfolioDesign/portafolioDisenoSensi.webp'
import imageIdea from '../assets/images/portfolio/portfolioDesign/portafolioDisenoIdea.webp'
import imageDiseMosaikus from '../assets/images/portfolio/portfolioDesign/portafolioDisenoMosaikus.webp'
import imageDiseSinergica from '../assets/images/portfolio/portfolioDesign/portafolioDisenoSinergica.webp'
// ________Web
import imagePi from '../assets/images/portfolio/portfolioWeb/webPi.webp'
import imageWebHispanos from '../assets/images/portfolio/portfolioWeb/webHispanos.webp'
import imageUrbit from '../assets/images/portfolio/portfolioWeb/webUrbitData.webp'
import imageUltraCell from '../assets/images/portfolio/portfolioWeb/webUltraCell.webp'
import imageAcei from '../assets/images/portfolio/portfolioWeb/webAcei.webp'
import imageAltaVista from '../assets/images/portfolio/portfolioWeb/webAltavista.webp'
import imageGuayoyo from '../assets/images/portfolio/portfolioWeb/webGuayoyoPublicidad.webp'
import imageAutismo from '../assets/images/portfolio/portfolioWeb/webAutismoyAlergias.webp'
import imageCanadian from '../assets/images/portfolio/portfolioWeb/webCanadianCasino.webp'
// ____Software
import imageSoftDigipagos from '../assets/images/portfolio/portfolioSoftware/portafolioSoftwareDigipagos.webp'
import imageSoftUda from '../assets/images/portfolio/portfolioSoftware/portafolioSoftwareUda.webp'
import imageSoftCoinyam from '../assets/images/portfolio/portfolioSoftware/portafolioSoftwareCoinyam.webp'
import imageRentaFb from '../assets/images/portfolio/portfolioSoftware/portafolioSoftwareRentaFB.webp'
import imageSoftBuscafy from '../assets/images/portfolio/portfolioSoftware/portafolioSoftwareBuscafy.webp'
import imageSoftIngresoViral from '../assets/images/portfolio/portfolioSoftware/portafolioSoftwareIngresoViral.webp'
import imageSoftProvitared from '../assets/images/portfolio/portfolioSoftware/portafolioSoftwareProvitared.webp'

/* eslint-disable  */
const categorias = {
  app: [
    {
      foto:imageGuia,
      nombre: 'Valentina Quintero',
      lugar: 'Turismo',
      fecha:'2016'
    },
    {
      foto: imageMosaikus,
      nombre: 'Mosaikus',
      lugar: 'Operación',
      fecha:'2017'
    },
    {
      foto:imageDigipagos,
      nombre: 'Digipagos',
      lugar: 'Operación',
      fecha:'2018'
    },
    {
      foto:imageMarco,
      nombre: 'Marco Aldany',
      lugar: 'Estética',
      fecha:'2016'
    },
    {
      foto:imageGlobal,
      nombre: 'Global Online',
      lugar: 'Entretenimiento',
      fecha:'2016'
    },
    ],
  web: [
    {
      foto: imageWebHispanos,
      nombre: 'Hispanos Emprendedores',
      url: 'hispanosemprendedores.com',
      pais:'USA',
      fecha:'2016'
    },
    {
      foto: imageCanadian,
      nombre: 'Canadian Casino',
      url: 'top7canadiancasino.com',
      pais:'USA',
      fecha:'2018'
    },
    {
      foto: imageUrbit,
      nombre: 'Urbit Data',
      url: 'urbitdata.com',
      pais:'España',
      fecha:'2018'
    },
    {
      foto: imagePi,
      nombre: 'PI Integral Solutions',
      url: 'pintegralsolutions.de',
      pais:'Alemania',
      fecha:'2016'
    },
    {
      foto: imageUltraCell,
      nombre: 'Ultracell Security System',
      url: 'ultracellsecuritysystem.com',
      pais:'Venezuela',
      fecha:'2016'
    },
    {
      foto: imageAcei,
      nombre: 'Grupo ACEI',
      url: 'grupoacei.com',
      pais:'Venezuela',
      fecha:'2018'
    },
    {
      foto: imageAltaVista,
      nombre: 'PI Integral Solutions',
      url: 'altavistalanguage.com',
      pais:'Venezuela',
      fecha:'2016'
    },
    {
      foto: imageAutismo,
      nombre: 'Autismo y Alergías',
      url: 'autismoyalergias.com',
      pais:'Venezuela',
      fecha:'2016'
    },
    {
      foto: imageGuayoyo,
      nombre: 'Guayoyo Publicidad',
      url: 'guayoyopublicidad.com.ve',
      pais:'Venezuela',
      fecha:'2016'
    },
    ],
  software: [
    {
      foto:imageRentaFb,
      nombre:'RENTA FB',
      subtitulo:'Unleash LTD',
      lugar: 'Bulgaria - 2018',
      descripcion:
        {
          es:'Un sistema compuesto de un API REST, cliente web y extensión de Chrome.',
          en: 'A system composed by a REST API, web client and Chrome extension.'
        },
      tecnologias:'PHP, Laravel, Mysql, JavaScript, Vue'
    },
    {
      foto:imageSoftCoinyam,
      nombre:'Coinyam/BTC Center',
      subtitulo:'Coinyam',
      lugar: 'España - 2018',
      descripcion:
        {
          es:'Un sistema para venta y compra de Cryptos. Esta compuesto de un API REST, cliente web y extensión de Chrome.',
          en: 'A system for buy and sale Cryptos. Composed by a REST API, web client and Chrome extension.'
        },
      tecnologias:'PHP, Laravel, Mysql, JavaScript, Vue'
    },
    {
      foto:imageSoftDigipagos,
      nombre:'Digipagos',
      subtitulo:'TI Soluciones',
      lugar: 'Venezuela - 2018',
      descripcion:{
        es:'Un sistema compuesto de un API REST, cliente web y extensión de Chrome.',
        en: 'A system composed by a REST API, web client and Chrome extension.'
      },
      tecnologias:'Java, Spring JPA, Android, PHP, Laravel, Postgres, JavaScript, React'
    },
    {
      foto:imageSoftUda,
      nombre:'UDA',
      subtitulo:'Lidernetwork',
      lugar: 'España - 2017',
      descripcion:{
        es:'Sistema de valuación de inmuebles basado en la extracción y comparación de datos de catastro y de sitios web inmobiliarios.',
        en: 'Property valuation system based on the extraction and comparison of cadastre data and real estate websites.'
      },
      tecnologias:'Java, Spring JPA, Android, PHP, Laravel, Mysql, Postgres, JavaScript'
    },
    {
      foto:imageSoftBuscafy,
      nombre:'Buscafy',
      subtitulo:'Lidernetwork',
      lugar: 'España - 2016',
      descripcion:{
        es:'Sistema de directorio de empresas tomadas desde el registro principal de España.',
        en: 'Directory system of companies taken from the main registry of Spain.'
      },
      tecnologias:'PHP, Mysql, JavaScript'
    },
    {
      foto:imageSoftIngresoViral,
      nombre:'Ingreso Viral',
      subtitulo:'Lidernetwork',
      lugar: 'España - 2017',
      descripcion:{
        es:'Sistema de contenidos y afiliación para plataforma de entrenamiento e ingresos en crypto divisas.',
        en: 'Content and affiliation system for training platform and income in crypto currency.'
      },
      tecnologias:'PHP, Laravel, Mysql, JavaScript'
    },
    {
      foto:imageSoftProvitared,
      nombre:'Provitared',
      subtitulo:'Provitared',
      lugar: 'Venezuela - 2017',
      descripcion:{
        es:'Sistema de intercambio y localización de medicamentos.',
        en: 'System of exchange and localization of medicines..'
      },
      tecnologias:'PHP, Laravel, Mysql, JavaScript, React'
    }
    ],
  design: [
    {
      foto:imageCachamay,
      nombre: 'Cachamay Runners',
      lugar: 'VENEZUELA',
      fecha:'2013'
    },
    {
      foto:imageSensi,
      nombre: 'Importadora SENSI C.A.',
      lugar: 'VENEZUELA',
      fecha:'2013'
    },
    {
      foto:imageIdea,
      nombre: 'IDEA',
      lugar: 'VENEZUELA',
      fecha:'2013'
    },
    {
      foto:imageDiseMosaikus,
      nombre: 'Mosaikus',
      lugar: 'CHILE',
      fecha:'2017'
    } ,
    {
      foto:imageDiseSinergica,
      nombre: 'Sinergica',
      lugar: 'VENEZUELA',
      fecha:'2013'
    },
    ]
}

export default categorias



// WEBPACK FOOTER //
// ./src/config/portafolio.js